export const subscribePendingStoreActions = store => store.subscribeAction({
  before: (action) => {
    store.commit('global/TOGGLE_PENDING_ASYNC_STORE_ACTIONS', action.type);
  },
  after: (action) => {
    store.commit('global/TOGGLE_PENDING_ASYNC_STORE_ACTIONS', action.type);
  },
});
